import React from "react";
import MeteredItemsPage from "../components/MeteredItemsPage";

function Items() {
    return (
        <MeteredItemsPage newDateRetries={3} />
    );
}

export default Items;
